import { i18n } from '../translate/i18n';

const monthToText = monthNumber => {
  switch(monthNumber) {
    case 0:
      return i18n.t('monthToText.0')
    case 1:
      return i18n.t('monthToText.1')
    case 2:
      return i18n.t('monthToText.2')
    case 3:
      return i18n.t('monthToText.3')
    case 4:
      return i18n.t('monthToText.4')
    case 5:
      return i18n.t('monthToText.5')
    case 6:
      return i18n.t('monthToText.6')
    case 7:
      return i18n.t('monthToText.7')
    case 8:
      return i18n.t('monthToText.8')
    case 9:
      return i18n.t('monthToText.9')
    case 10:
      return i18n.t('monthToText.10')
    case 11:
      return i18n.t('monthToText.11')
    default:
      return i18n.t('monthToText.12')
  }
}


export default monthToText;
